module.exports = __webpack_public_path__ + "img/156.7e4a1019.jpg";